import React from 'react';
import { BaseModal } from '../BaseModal';
import { Typography, Button } from '@utex/ui-kit';
import { useTranslation } from 'react-i18next';

interface Props {
  onButtonClick?: () => void;
  onRequestClose: () => void;
}

export const DownloadModal = (props: Props) => {
  const { onButtonClick } = props;
  const { t } = useTranslation('deposit');

  return (
    <BaseModal
      icon="info"
      testId="downloadInfoModal"
      title={t('Download Title')}
      footer={
        <Button isLong={true} view="alert" onClick={onButtonClick}>
          {t('Download Button Text')}
        </Button>
      }
      onRequestClose={props.onRequestClose}
    >
      <Typography.Text>{t('Download Text')}</Typography.Text>
    </BaseModal>
  );
};
